export class User {
  id!: number;
  title!: string;
  firstName!: string;
  lastName!: string;
  email!: string;
  password!: string;
  resetToken: string;
}

export class UserPass {
    password: string;
    resetToken: string;
}